import React, { useState, useEffect } from "react";
import { Drawer, Row, Col, Card, Image, Result } from "antd";
import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  ExceptionOutlined,
} from "@ant-design/icons";
import { API } from "aws-amplify";
import { List } from "@mui/material";
import MainHeader from "../../../../common/MainHeader";
import prescriptionBW from "../../../../../assets/images/prescriptionBW.png";

export default function MedicalInfo(props) {
  const [isLoading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [prescriptionIndex, setprescriptionIndex] = useState(0);
  const [prescriptionList, setprescriptionList] = useState([]);
  const [prescriptionInfo, setprescriptionInfo] = useState("");

  useEffect(() => {
    const { profileId } = props;
    getPrescriptionsList(profileId);
  }, [props]);

  const getPrescriptionsList = async (profileId) => {
    setLoading(true);
    await API.get(
      "get",
      `/mobile/list/getUserDocuments/${profileId}?recordType=file&dataType=pf`,
      {}
    )
      .then(async (response) => {
        setprescriptionList(response);
        setLoading(false);
      })
      .catch((error) => {
        alert("Something went wrong");
        console.log("Error:", error.response);
        setLoading(false);
        setprescriptionList([]);
      });
  };

  const warningInfo = (info) => {
    setprescriptionInfo(info);
    setOpen(true);
  };

  const warningInfoSwap = (currentWarningIconIndex) => {
    let info = prescriptionList[currentWarningIconIndex];
    setprescriptionInfo(info);
    setprescriptionIndex(currentWarningIconIndex);
  };

  const LabelValue = (label, value) => {
    return (
      <div>
        <div  style={{ color: "#767676", fontSize: "10px", marginTop:"-1px" }}>
          <span>{label}</span>
        </div>
        <div style={{ color: "#000", fontSize: "12px", marginTop:"-5px" }}>
          <span >{value}</span>
        </div>
      </div>
    );
  };

  return (
    <div style={{ background: "#FFF", borderRadius: "10px", padding: "28px" }}>
      <MainHeader title={`Prescriptions ( ${prescriptionList.length} )`} />

      <div
        style={{
          minHeight: "335px",
          maxHeight: "335px",
          overflow: "auto",
          overflowX: "hidden",
        }}
      >
        <div
          style={{
            borderRadius: "10px",
            background: "#f5f5f5",
            marginTop: "20px",
            minHeight: "310px",
              padding: "0px 5px 0px",
          }}
        >
          {prescriptionList?.length > 0 ? (
            <List>
              <Row>
                {prescriptionList.map((prescription, index) => (
                  <Col
                    xxl={{ span: 12 }}
                    xl={{ span: 12 }}
                    lg={{ span: 12 }}
                    md={{ span: 24 }}
                    sm={{ span: 24 }}
                    xs={{ span: 24 }}
                  >
                    <Card
                      className="card-container"
                      hoverable
                      bodyStyle={{ margin: "0px", padding: "5px" }}
                      style={{ margin: "5px" }}
                      onClick={() => warningInfo(prescription)}
                    >
                      <Row gutter={[8, 8]} key={index}>
                        <Col>
                          <Image
                            src={
                              prescription?.frontCard?.securedFileUrl ||
                              prescriptionBW
                            }
                            width={60}
                            height={79}
                            style={{
                              borderRadius: "5px",
                              background: "#d5d5d5",
                              objectFit: "cover",

                            }}
                          />
                        </Col>
                        <Col>
                          <div>
                            <span
                              style={{ fontSize: "14px", fontWeight: "600" }}
                            >
                              {prescription?.prescriptionName}
                            </span>
                          </div>
                          {LabelValue("Dosage", prescription?.dosage || "N/A")}
                          {LabelValue("Route", prescription?.route || "N/A")}
                        </Col>
                      </Row>
                    </Card>
                  </Col>
                ))}
              </Row>
            </List>
          ) : (
            <Row justify={"center"}>
              <Col
                style={{
                  padding: "30px",
                  textAlign: "center",
                  marginTop: "50px",
                }}
              >
                <ExceptionOutlined
                  style={{ fontSize: "100px", color: "#ccc" }}
                />
                <h3 style={{ textAlign: "center", color: "#ccc" }}>
                  Prescriptions Not Found
                </h3>
              </Col>
            </Row>
          )}
        </div>
        <Drawer
          title={null}
          placement="top"
          closable={false}
          onClose={() => setOpen(false)}
          open={open}
          getContainer={false}
          style={{ borderRadius: "10px" }}
        >
          <Row justify="space-between">
            <Col>
              {prescriptionIndex !== 0 && (
                <ArrowLeftOutlined
                  style={{
                    fontSize: "22px",
                    color: "#6a347d",
                    cursor: "pointer",
                  }}
                  onClick={() => warningInfoSwap(prescriptionIndex - 1)}
                />
              )}
            </Col>

            <Col>
              <div onClick={() => setOpen(false)}>
                <span
                  style={{
                    fontSize: "22px",
                    color: "tomato",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                >
                  Close
                </span>
              </div>
            </Col>

            <Col>
              {prescriptionList &&
                prescriptionList.length !== prescriptionIndex + 1 && (
                  <ArrowRightOutlined
                    style={{
                      fontSize: "22px",
                      color: "#6a347d",
                      cursor: "pointer",
                    }}
                    onClick={() => warningInfoSwap(prescriptionIndex + 1)}
                  />
                )}
            </Col>
          </Row>

          <Result
            icon={
              <Image
                src={
                  prescriptionInfo?.frontCard?.securedFileUrl || prescriptionBW
                }
                width={84}
                height={84}
                style={{
                  borderRadius: "10px",
                  background: "#d5d5d5",
                  objectFit: "cover",
                }}
              />
            }
            status="success"
            title={
              prescriptionInfo?.prescriptionName
                ? prescriptionInfo?.prescriptionName
                : ""
            }
            subTitle={
              <div>
                <h4 style={{ textAlign: "center", marginTop: "-5px" }}>
                  {prescriptionInfo.notes ? prescriptionInfo.notes : ""}
                </h4>
                <p style={{ textAlign: "center", marginTop: "-10px" }}>
                  Dosage : {prescriptionInfo?.dosage}
                </p>
                <p style={{ textAlign: "center", marginTop: "-10px" }}>
                  Frequency : {prescriptionInfo?.frequency}
                </p>
                <p style={{ textAlign: "center", marginTop: "-10px" }}>
                  Route : {prescriptionInfo?.route}
                </p>
              </div>
            }
          />
        </Drawer>
      </div>
    </div>
  );
}
